/**
 * idleCallback
 * ─────────────────────────────────────────────────────────────────────────────
 * `requestIdleCallback` / `cancelIdleCallback` are DOM APIs. Expo's base
 * tsconfig pulls in the `dom` lib, so TypeScript happily type-checks direct
 * calls to them — but neither exists at runtime on React Native (Hermes) nor
 * in Safari, which has never implemented `requestIdleCallback`. A direct call
 * throws `ReferenceError: Can't find variable: requestIdleCallback`,
 * uncaught, before the deferred fetch inside it ever runs.
 *
 * These wrappers use the native APIs when present and fall back to a
 * `setTimeout` of 0 otherwise, matching the common polyfill shape (deadline
 * argument omitted — none of our call sites use it).
 */

export function scheduleIdleCallback(callback: () => void): number {
  if (typeof requestIdleCallback === 'function') {
    return requestIdleCallback(callback) as unknown as number;
  }
  return setTimeout(callback, 0) as unknown as number;
}

export function cancelIdleCallback(handle: number): void {
  if (typeof globalThis.cancelIdleCallback === 'function' && typeof requestIdleCallback === 'function') {
    globalThis.cancelIdleCallback(handle);
    return;
  }
  clearTimeout(handle);
}
